<app-menu (menuEvent)="handleFunctionEvent($event)" [screen]="screen"></app-menu>
<app-users [users]="users" [loading]="loading"></app-users>